import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import Fetch from '@/utils/Fetch';

const validate = (inputs: any, selectedInventoryCategory: any, selectedInventorySubcategory: any) => {

  let validationItems = [
    {key: 'Description', value: inputs.Description, required: true, type: Enums.ControlType.Text},
    {key: 'InventoryCategoryDescription', value: selectedInventoryCategory, required: true, type: Enums.ControlType.Select},
    {key: 'InventorySubcategoryDescription', value: selectedInventorySubcategory, required: true, type: Enums.ControlType.Select},
    {key: 'StockItemTypeDescription', value: inputs.StockItemTypeDescription, required: true, type: Enums.ControlType.Text},
    {key: 'CostPrice', value: inputs.CostPrice, required: true, type: Enums.ControlType.Number},
    {key: 'ListPrice', value: inputs.ListPrice, required: true, type: Enums.ControlType.Number},
    {key: 'CommissionPercentage', value: inputs.CommissionPercentage, required: true, type: Enums.ControlType.Number},
    {key: 'Quantity', value: inputs.Quantity, required: true, type: Enums.ControlType.Number},
    {key: 'WarrantyPeriod', value: inputs.WarrantyPeriod, required: true, type: Enums.ControlType.Number},
  ];

  return Helper.validateInputs(validationItems);
};

const getInventoryList = async (searchPhrase: any, pageSize: any, currentPage: any, activeFilterIds: any, ancillaryFilters: any, sortField: any, sortDirection: any, toast = null) => {
    let params: Record<string, any> = {
        pageSize,
        pageIndex: (currentPage - 1),
        searchPhrase,
        sortExpression: sortField,
        sortDirection: sortDirection
    };

    if (activeFilterIds) {
        params = {...params,
            CategoryIDList: activeFilterIds["Categories"],
            SubcategoryIDList: activeFilterIds["Subcategories"],
            SupplierIDList: activeFilterIds["Suppliers"],
            StockItemTypeIDList: activeFilterIds["StockItemTypes"],
        };
    }

    if (ancillaryFilters) {
        params = {...params,
            IncludeClosed: ancillaryFilters["IncludeDisabled"],
        }
    }

    return await Fetch.post({
        url: `/Inventory/GetInventories`,
        params: params,
        toastCtx: toast
    });
};

const getInventory = async (id: any) => {
  return await Fetch.get({
    url: `/Inventory?id=${id}`
  });
};

// INVENTORY CATEGORY

const getAllInventoryCategories = async () => {
    return await Fetch.get({
        url: `/InventoryCategory/false`
    });
};

const getInventoryCategory = async (id: any) => {
  let result = null;
  if (id) {
      result = await Fetch.get({
          url: `/InventoryCategory?id=${id}`
      });
  }
  return result;
};

const validateInventoryCategory = (inputs: any) => {
  let validationItems = [
    {key: 'Description', value: inputs.Description, required: true, type: Enums.ControlType.Text}
  ];
  return Helper.validateInputs(validationItems);
};

// INVENTORY SUBCATEGORY

const getAllInventorySubCategories = async () => {
    return await Fetch.get({
        url: `/InventorySubcategory/GetOnlyActive?onlyActive=false`
    });
};

const validateInventorySubcategory = (inputs: any, selectedInventoryCategory: any) => {
  let validationItems = [
    {key: 'Description', value: inputs.Description, required: true, type: Enums.ControlType.Text},
    {key: 'InventoryCategory', value: selectedInventoryCategory, required: true, type: Enums.ControlType.Select},
  ];
  return Helper.validateInputs(validationItems);
};

export default {
  validate,
  getInventoryList,
  getInventory,
  
  getAllInventoryCategories,
  getInventoryCategory,  
  validateInventoryCategory,

  getAllInventorySubCategories,
  validateInventorySubcategory,
};
